import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProjectDataService {
  projectInformation: any;
  allocatedResource: any;
  selectedBilling: any;
  saveProjectInfo = new Subject();
  updateProjectInfo = new Subject();
  saveProjectStatus = false;
  updateProjectStatus = false;

  billingTypeData = [
    { name: 'Fixed Billable', value: 'Fixed Billable' },
    { name: 'Fixed Non-Billable', value: 'Fixed Non-Billable' },
    { name: 'Time and Material Billable', value: 'Time and Material Billable' },
    { name: 'Time and Material Non-Billable', value: 'Time and Material Non-Billable' }
  ];
  constructor() { }
}
